import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HeaderTable from 'components/Table/HeaderTable';
import BodyTable from 'components/Table/BodyTable';
import PaginationTable from 'components/Table/PaginationTable';
import FilterTable from 'components/Table/FilterTable';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';

class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            array: structuredClone(this.props.data.projects),
            arrayCompare: structuredClone(this.props.data.projects),
            arraySplit: [],
            headerData: ['Dialog Flow ID', 'Language', 'Centribot Project ID', 'High Performance']
        }
    }

    componentDidMount() {
        this.splitArray();
    }

    componentDidUpdate(prevProps) {
        const { projects } = this.props.data;
        if (projects !== prevProps.data.projects) {
            this.setState({
                array: structuredClone(projects),
                arrayCompare: structuredClone(projects)
            }, () => {
                this.splitArray(0, this.state.arrayCompare);
            });
        }
    }

    splitArray = (i = 0, data) => {
        const sourceData = data !== undefined ? data : this.state.arrayCompare;
        const sourceArray = Array.isArray(sourceData) ? [...sourceData] : [];
        
        if (sourceArray.length === 0) {
            this.setState({ array: [], arraySplit: [], arrayCompare: [] });
            return;
        }
        const arr = [];
        let tempArray = [...sourceArray];
        while (tempArray.length) {
            arr.push(tempArray.splice(0, 10));
        }

        this.setState({
            array: arr[i] || [],
            arraySplit: arr,
            ...(data !== undefined && { arrayCompare: sourceArray })
        });
    };

    createElement = (e) => {
        e.preventDefault();
        this.props.history.push('/projects/create');
    }

    render() {
        const { headerData, array, arrayCompare, arraySplit } = this.state;
        const { projects } = this.props.data;
        return (
            <React.Fragment>
                {
                    projects.length === 0 ? (
                        <span className="cen-noInfo">No projects found.</span>
                    ) : (
                            <React.Fragment>
                                {arrayCompare && arrayCompare.length > 0 && (
                                    <FilterTable update={this.splitArray} data={arrayCompare} type={'project'} />
                                )
                                }
                                {array.length > 0 ? (
                                    <React.Fragment>
                                        <HeaderTable data={headerData} />
                                        <BodyTable remove data={array} history={this.props.history} />
                                        {
                                            arrayCompare.length > 10 &&
                                            <PaginationTable update={this.splitArray} data={arraySplit} />
                                        }
                                    </React.Fragment>
                                ) : (
                                        <span className="cen-noInfo">No results found.</span>
                                    )}
                            </React.Fragment>
                        )
                }
                <IconButton className="cen-btn-new" aria-label="delete" onClick={this.createElement}>
                    <AddIcon fontSize="large" />
                </IconButton>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    }
}

const connect_project = connect(
    mapStateToProps
)(Project);

Project.propTypes = {
    data: PropTypes.shape({
        projects: PropTypes.array.isRequired,
        updateProjects: PropTypes.bool
    }).isRequired,
    history: PropTypes.object.isRequired
};

export default withRouter(connect_project);